import { createContext, useContext, useState, useEffect } from "react";
import { MENU_ITEM } from "../utils/constants";
import { STORAGE_KEY } from "utils/strings";

interface TabBarContextType {
  selectedTabBar: string;
  setSelectedTabBar: (menu: string) => void;
}

const TabBarContext = createContext<TabBarContextType | undefined>(undefined);

export const TabBarProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedTabBar, setSelectedTabBar] = useState(MENU_ITEM.HOME);

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY.SELECTED_HOME_TAB_DATA, selectedTabBar);
  }, [selectedTabBar]);

  return (
    <TabBarContext.Provider value={{ selectedTabBar, setSelectedTabBar }}>
      {children}
    </TabBarContext.Provider>
  );
};

export const useTabBar = () => {
  const context = useContext(TabBarContext);
  if (context === undefined) {
    throw new Error("useTabBar must be used within a TabBarProvider");
  }
  return context;
};
